// extracted by mini-css-extract-plugin
module.exports = {"download":"report_download__3yks5","QRwrapper":"report_QRwrapper__2aiTn"};